import Vue from "vue";
import moment from "moment";

function initialState() {
  return {
    Widgets: [],
    DashboardStats: {},
    CustomerEngagementData: [],
    TeamManagementData: [],
    ServiceLeadManagementData: [],
    // showBackButton: false,
    ActivityIcons: [
      {
        type: 1,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-reviews-lake.svg"
      },
      {
        type: 2,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-task-list-lake.svg"
      },
      {
        type: 3,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-website-lake.svg"
      },
      {
        type: 4,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-phone-lake.svg"
      },
      {
        type: 5,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-email-lake.svg"
      },
      {
        type: 6,
        src:
          "https://assets.autoalert.com/img/autoalert-icons/icon-dealsheet-lake.svg"
      }
    ],
    WidgetPermissions: [
      {
        viewName: "DashboardWidget",
        viewTitle: "Dashboard",
        viewIcon:
          "https://assets.autoalert.com/img/autoalert-icons/icon-dashboard-lake.svg",
        isManager: true,
        isBDCManager: true,
        isSalesPerson: true
      },
      {
        viewName: "TeamManagementWidget",
        viewTitle: "Team Management",
        viewIcon:
          "https://assets.autoalert.com/img/autoalert-icons/icon-group-2-lake.svg",
        isManager: true,
        isBDCManager: true,
        isSalesPerson: false
      },
      {
        viewName: "CustomerEngagementWidget",
        viewTitle: "Customer Engagement",
        viewIcon:
          "https://assets.autoalert.com/img/autoalert-icons/icon-engagement-lake.svg",
        isManager: true,
        isBDCManager: true,
        isSalesPerson: true
      },
      {
        viewName: "ServiceLeadManagementWidget",
        viewTitle: "Service Lead Management",
        viewIcon: "static/assets/img/SVGIcons/icon-car-driving-lake.svg",
        isManager: true,
        isBDCManager: false,
        isSalesPerson: false
      },
      {
        viewName: "LeadManagementWidget",
        viewTitle: "My Leads",
        viewIcon:
          "https://assets.autoalert.com/img/autoalert-icons/icon-lead-management-lake.svg",
        isManager: false,
        isBDCManager: false,
        isSalesPerson: true
      }
    ],
    DealSheetId: {
      id: 0,
      type: ""
    },
    TeamMemberQueryObject: {},
    selectedTab: "",
    savedFilters: setSaveFilters()
  };
}

const state = initialState();

function setSaveFilters() {
  return {
    managerDashboard: {
      DashboardWidget: {},
      TeamManagementWidget: {},
      CustomerEngagementWidget: {},
      ServiceLeadManagementWidget: {}
    },
    bdcDashboard: {
      DashboardWidget: {},
      TeamManagementWidget: {},
      CustomerEngagementWidget: {},
      ServiceLeadManagementWidget: {}
    },
    salesDashboard: {
      DashboardWidget: {},
      CustomerEngagementWidget: {},
      LeadManagementWidget: {}
    },
    Reporting: {
      UserActivity: {},
      Sold: {},
      Engagement: {}
    },
    Mobile: {
      LeadMobile: {},
      TeamMobile: {}
    }
  };
}

const getters = {
  Widgets(state) {
    return state.Widgets;
  },
  DashboardStats(state) {
    return state.DashboardStats;
  },
  CustomerEngagementData(state) {
    return state.CustomerEngagementData;
  },
  TeamManagementData(state) {
    return state.TeamManagementData;
  },
  ServiceLeadManagementData(state) {
    return state.ServiceLeadManagementData;
  },
  ActivityIcons(state) {
    return state.ActivityIcons;
  },
  DealSheetId(state) {
    return state.DealSheetId;
  },
  TeamMemberQueryObject(state) {
    return state.TeamMemberQueryObject;
  },
  selectedTab(state) {
    return state.selectedTab;
  },
  savedFilters(state) {
    return state.savedFilters;
  }
  // showBackButton(state) {
  //   return state.showBackButton
  // }
};

const actions = {
  getWidgets(context, role) {
    context.dispatch("setDetailsView", "");
    let widgets = [];
    let newrole = "";

    if (role) {
      if (context.getters.isManager && role === "managerDashboard") {
        widgets = state.WidgetPermissions.filter(f => f.isManager);
      } else if (context.getters.isBDCManager && role === "bdcDashboard") {
        widgets = state.WidgetPermissions.filter(f => f.isBDCManager);
      } else if (context.getters.isSalesPerson && role === "salesDashboard") {
        widgets = state.WidgetPermissions.filter(f => f.isSalesPerson);
      }
      context.commit("Widgets", { widgets: widgets, role: role });
    } else {
      if (context.getters.isManager) {
        widgets = state.WidgetPermissions.filter(f => f.isManager);
        newrole = "managerDashboard";
      } else if (context.getters.isBDCManager) {
        widgets = state.WidgetPermissions.filter(f => f.isBDCManager);
        newrole = "bdcDashboard";
      } else if (context.getters.isSalesPerson) {
        widgets = state.WidgetPermissions.filter(f => f.isSalesPerson);
        newrole = "salesDashboard";
      }
      context.commit("Widgets", { widgets: widgets, role: newrole });
      context.commit("selectedTab", newrole);
    }
  },
  getServiceLeadManagementData(context, request) {
    return new Promise(async (resolve, reject) => {
      let accountPlatformIds = request.filter.stores.map(
        m => m.AccountPlatformID
      );
      let startReportDate = moment(
        request.filter.dateFilter.beginDate
      ).toISOString();
      startReportDate = startReportDate.substring(
        0,
        startReportDate.length - 1
      );
      let endReportDate = moment(
        request.filter.dateFilter.endDate
      ).toISOString();
      endReportDate = endReportDate.substring(0, endReportDate.length - 1);

      let filter = {
        AccountPlatformIDs: accountPlatformIds,
        //StartReportDate: moment("2018-05-06T05:00:00.000Z"),
        //for testing
        StartReportDate: startReportDate,
        EndReportDate: endReportDate,
        // PrivateOffer: request.filter.privateOffer,
        PreApproval: request.filter.preApproval,
        ForceRefresh: true,
        SlmActivityType: request.slmType
      };
      resolve(
        await Vue.http
          .post("pando/pandoalertreporting/activitydetails", filter)
          .then(data => {
            if (data.data && data.data.Data) {
              let slmData = [];
              Array.prototype.push.apply(slmData, data.data.Data.Appointments);
              Array.prototype.push.apply(slmData, data.data.Data.Completed);
              Array.prototype.push.apply(slmData, data.data.Data.Working);
              resolve(slmData);
            } else reject(data);
          })
          .catch(resp => {
            reject(resp);
          })
      );
    });
  },
  getSLMCounts(context, request) {
    return new Promise(async (resolve, reject) => {
      let requestPayload = {
        AccountPlatformIDs: request.stores.map(m => m.AccountPlatformID),
        StartReportDate: moment(request.dateFilter.beginDate),
        EndReportDate: moment(request.dateFilter.endDate),
        PrivateOffer: request.privateOffer,
        PreApproval: request.preApproval,
        ForceRefresh: true
      };
      resolve(
        await Vue.http
          .post("pando/pandoalertreporting/activitycount", requestPayload)
          .then(resp => {
            if (resp.data && resp.data.Data) resolve(resp.data.Data);
            else return reject(resp);
          })
          .catch(resp => {
            reject(resp);
          })
      );
    });
  },
  setDealSheetId(context, id) {
    context.commit("DealSheetId", id);
  },
  savedFilters(context, filter) {
    context.commit("savedFilters", filter);
    context.dispatch("setFilterCookie");
  },
  setSavedFilterFromCookie(context, userIdAccountId) {
    context.dispatch("getFilterCookie", userIdAccountId).then(cookie => {
      if (cookie) {
        context.commit("saveFiltersFromCookie", cookie);
      }
      context.dispatch("setUserIdAccountId", userIdAccountId);
    });
  },
  setTeamMemberQueryObject(context, data) {
    context.commit("TeamMemberQueryObject", data);
  }
};

const mutations = {
  Widgets(state, data) {
    if (data.widgets.length > 0) {
      if (data.role === "salesDashboard") {
        data.widgets.find(x => x.viewTitle.includes("Dashboard")).viewTitle =
          "My Dashboard";
        data.widgets.find(x => x.viewTitle.includes("Engagement")).viewTitle =
          "My Customer Engagement";
      } else {
        data.widgets.find(x => x.viewTitle.includes("Dashboard")).viewTitle =
          data.role + " Dashboard";
        data.widgets.find(x => x.viewTitle.includes("Engagement")).viewTitle =
          "Customer Engagement";
      }
    }
    state.Widgets = data.widgets;
  },
  DashboardStats(state, data) {
    state.DashboardStats = data;
  },
  CustomerEngagementData(state, data) {
    state.CustomerEngagementData = data;
  },
  TeamManagementData(state, data) {
    state.TeamManagementData = data;
  },
  ServiceLeadManagementData(state, data) {
    state.ServiceLeadManagementData = data;
  },
  DealSheetId(state, data) {
    state.DealSheetId = data;
  },
  selectedTab(state, data) {
    state.selectedTab = data;
  },
  savedFilters(state, data) {
    state.savedFilters[data.key][data.widget][data.filter] = data.value;
  },
  saveFiltersFromCookie(state, data) {
    state.savedFilters = data;
  },
  TeamMemberQueryObject(state, data) {
    state.TeamMemberQueryObject = data;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Widgets.js